<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="充值价格" prop="rechargePrice" >
        <a-input-number :min="1" v-model="form.rechargePrice" placeholder="请输入充值价格" />
      </a-form-model-item>
      <a-form-model-item label="充值金币" prop="rechargeDiamond" >
        <a-input-number :min="1" v-model="form.rechargeDiamond" placeholder="请输入充值金币" />
      </a-form-model-item>
      <a-form-model-item label="优惠内容" prop="preferential" >
        <a-input :min="1" :max="100" v-model="form.preferential" placeholder="请输入优惠内容" />
      </a-form-model-item>
      <a-form-model-item label="赠送金币" prop="giveDiamond" >
       <a-input-number :min="1" v-model="form.giveDiamond" placeholder="请输入赠送钻石"  />
     </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注"  />
      </a-form-model-item>
      <a-form-model-item label="英文备注" prop="remarkEn" >
        <a-input  v-model="form.remarkEn" placeholder="请输入英文备注"  />
      </a-form-model-item>
      <a-form-model-item label="日语备注" prop="remarkJa" >
        <a-input  v-model="form.remarkJa" placeholder="请输入日语备注"  />
      </a-form-model-item>
      <a-form-model-item label="印尼备注" prop="remarkId" >
        <a-input  v-model="form.remarkId" placeholder="请输入印尼备注"  />
      </a-form-model-item>
      <a-form-model-item label="葡语语备注" prop="remarkPt" >
        <a-input  v-model="form.remarkPt" placeholder="请输入葡语备注"  />
      </a-form-model-item>
      <a-form-model-item label="西语备注" prop="remarkEs" >
        <a-input  v-model="form.remarkEs" placeholder="请输入西语备注"  />
      </a-form-model-item>
      <a-form-model-item label="sort" prop="sort" >
        <a-input  v-model="form.sort" placeholder="请输入排序规则"  />
      </a-form-model-item>

<!--      <a-form-model-item label="ios内购产品ID" prop="productId" >-->
<!--        <a-input v-model="form.productId" placeholder="请输入ios内购产品ID"  />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRechargeMenu, addRechargeMenu, updateRechargeMenu } from '@/api/rechargeMenu/rechargeMenu.js'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',

      // 表单参数
      form: {
        id: null,

        rechargePrice: null,

        rechargeDiamond: null,
        giveDiamond: null,
        productId: null,

        createTime: null,

        remark: null,
        remarkEn: null,
        remarkJa: null,
        remarkId: null,
        remarkPt: null,
        remarkEs: null,
        sort: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        rechargePrice: [
          { required: true, message: '充值价格不能为空' }
        ],
        rechargeDiamond: [
          { required: true, message: '充值钻石不能为空' }
        ],
        // preferential: [
        //   { required: true, message: '优惠百分比%不能为空' }
        // ],
        productId: [
          { required: true, message: 'ios内购产品id不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        rechargePrice: null,
        rechargeDiamond: null,
        productId: null,
        giveDiamond: null,
        createTime: null,
        remark: null,
        sort: null
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRechargeMenu({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRechargeMenu(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRechargeMenu(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
